'use client'

// Narrow, per-concern selector hook for the shipping-country picker (#118
// server-chrome, Step 1; Overmind→Zustand region store, Phase C2 part 2).
// Read-seam discipline: exposes ONLY the region store's `countries` (the option
// list, populated post-mount by regionStore.getCountries), `shippingCountry` (the
// selected code, overlaid post-mount) and `countriesLoading` (the picker's loading
// flag) — nothing else. The picker renders in the server SiteChrome shell (footer)
// OUTSIDE the page-content provider tree, so these come from the GLOBAL Zustand
// region store, not a React context provider.
//
// isLoading NOTE: the former seam returned the Overmind GLOBAL `state.isLoading`;
// this returns the region store's `countriesLoading` (true only while the country
// list fetch is in flight) — the picker's own loading concern, decoupled from the
// unrelated global commerce loading flag.

import { useRegionStore } from '../../../store/regionStore'

export function useShippingCountry() {
  const countries = useRegionStore((s) => s.countries)
  const shippingCountry = useRegionStore((s) => s.shippingCountry)
  const isLoading = useRegionStore((s) => s.countriesLoading)
  return { countries, shippingCountry, isLoading }
}
